<template>
  <div>
    <ValidationObserver ref="form" v-slot="{ invalid }">
      <form @submit.prevent="onSubmit" ref="_form">
        <table class="table is-fullwidth">
          <tr>
            <!-- day -->
            <td>
              <ValidationProvider
                name="doctor_schedule_day"
                rules="required"
                v-slot="{ errors }"
              >
                <b-field
                  :type="errors[0] ? 'is-danger' : ''"
                  label="Dia"
                  label-position="on-border"
                >
                  <b-select v-model="schedule.day">
                    <option
                      v-for="item in weekDays"
                      :value="item.day"
                      :key="item.day"
                    >
                      {{ item.name }}
                    </option>
                  </b-select>
                </b-field>
              </ValidationProvider>
            </td>
            <!-- start -->
            <td>
              <ValidationProvider
                name="doctor_schedule_start"
                rules="required"
                v-slot="{ errors }"
              >
                <b-field
                  :message="errors[0]"
                  :type="errors[0] ? 'is-danger' : ''"
                  label="Início"
                  label-position="on-border"
                >
                  <b-input v-model="schedule.start" type="time"></b-input>
                </b-field>
              </ValidationProvider>
            </td>
            <!-- end -->
            <td>
              <ValidationProvider
                name="doctor_schedule_end"
                rules="required"
                v-slot="{ errors }"
              >
                <b-field
                  :message="errors[0]"
                  :type="errors[0] ? 'is-danger' : ''"
                  label="Fim"
                  label-position="on-border"
                >
                  <b-input v-model="schedule.end" type="time"></b-input>
                </b-field>
              </ValidationProvider>
            </td>
            <!-- button submit -->
            <td>
              <b-button :disabled="invalid" native-type="submit" class="is-info"
                >Enviar</b-button
              >
            </td>
          </tr>
          <tr v-for="schedule in schedules" :key="schedule._id">
            <td>{{ schedule.day | dayName(weekDays) }}</td>
            <td>{{ schedule.start }}</td>
            <td>{{ schedule.end }}</td>
            <td class="is-flex is-align-content-flex-end">
              <a @click.prevent="setSchedule(schedule)">
                <b-icon icon="pencil-outline" class="button has-text-info">
                </b-icon>
              </a>
              <a @click.prevent="deleteSchedule(schedule._id)">
                <b-icon icon="trash-can-outline" class="button has-text-danger">
                </b-icon>
              </a>
            </td>
          </tr>
        </table>
      </form>
    </ValidationObserver>
    <!-- schedule form -->
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
  name: "OfficeSchedules",
  props: ["officeId", "schedules"],
  components: { ValidationProvider, ValidationObserver },
  data() {
    return {
      weekDays: [
        { day: 1, name: "SEG" },
        { day: 2, name: "TER" },
        { day: 3, name: "QUA" },
        { day: 4, name: "QUI" },
        { day: 5, name: "SEX" },
        { day: 6, name: "SÁB" },
        { day: 0, name: "DOM" },
      ],
      schedule: {},
    };
  },
  filters: {
    dayName(day, weekDays) {
      return weekDays.filter((f) => f.day == day)[0].name;
    },
  },
  methods: {
    setSchedule(schedule = {}) {
      this.schedule = Object.assign({}, schedule);
    },
    onSubmit() {
      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }

        if (this.schedule._id) {
          this.$http
            .put(
              `office/schedule/${this.officeId}/${this.schedule._id}`,
              this.schedule
            )
            .then(() => {
              let schedules = this.schedules.map((v) => {
                if (v._id == this.schedule._id) v = this.schedule;
                return v;
              });
              this.$emit("updateSchedules", schedules);
            });
        }

        if (!this.schedule._id) {
          this.$http
            .post(`office/schedule/${this.officeId}`, this.schedule)
            .then((response) => {
              this.schedule._id = response.data._id;
              this.schedules.push(this.schedule);
              this.$refs.form.reset();
              this.schedule = {};
            });
        }
      });
    },
    toggle(schedule) {
      this.$http.put(
        `office/schedule/${this.officeId}/${schedule._id}`,
        schedule
      );
    },
    deleteSchedule(scheduleId) {
      const self = this;
      self.$buefy.dialog.confirm({
        title: "Excluir Horário",
        message: "Essa operação não poderá ser desfeita",
        confirmText: "Sim Excluir",
        type: "is-danger",
        hasIcon: false,
        onConfirm: function () {
          this.$http
            .delete(`office/schedule/${self.officeId}/${scheduleId}`)
            .then(() => {
              let schedules = self.schedules.filter((f) => f._id != scheduleId);
              self.$emit("updateSchedules", schedules);
            });
        },
      });
    },
  },
};
</script>
